import http from "../http-common";

class FaxDataService {
  getAll() {
    return http.get("/tutorials");
  }
}

export default new FaxDataService();
